import Axios from '../components/Axios'

export const getProductList = (update) => {
	return Axios('POST', 'officialWeb/getProductList', update)
}


export const getProductInfo = (id) => {
	return Axios('GET', `officialWeb/getProductInfo/${id}`)
}
